import { gql } from '@apollo/client'

export const SearchLeadQuery = gql`
  query SearchLead($email: String!) {
    leadCustomer {
      searchLead(email: $email) {
        id
        isNewsletterSubscribed
      }
    }
  }
`

export const SubscribeToNewsletterMutation = gql`
  mutation SubscribeToNewsletter($input: NewsletterSubscribeInput!) {
    leadCustomer {
      subscribeToNewsletter(input: $input)
    }
  }
`

export const UnsubscribeFromNewsletterMutation = gql`
  mutation UnsubscribeFromNewsletter($input: NewsletterSubscribeInput!) {
    leadCustomer {
      unsubscribeFromNewsletter(input: $input)
    }
  }
`
